
"use strict"; // jshint ignore:line

import { CommentsHandler } from '../services/CommentsService.js';
import { ObjectClickHandler }  from '../../utils/object-click-handler.js';
import { isObjectMoveable }  from '../../utils/object-properties/is-object.js';
import Helpers             from '../classes/Helpers.js';
import {
	parseFirstIntersect,
	screenIntersects
} from '../GameTools.js';


import {
	Group,
	Vector3,
	Matrix4,
	Object3D,
	SphereGeometry,
	MeshBasicMaterial,
	MeshPhongMaterial,
	Geometry,
	Face3,
	Mesh,
	DoubleSide,
	FrontSide,
	ShaderMaterial,
	Color,
	Plane
} from '../../../src/js/three.module.js';

export default class DragHandlesService {

	static $inject = ["$rootScope","$compile","$templateRequest","$timeout","userActionHistoryService"]; // jshint ignore:line

	constructor( $rootScope,  $compile,  $templateRequest,  $timeout,  userActionHistoryService ) {

		var self = window.DragHandlesService = this;
		this.handles = new Group();
		this.handles_by_uuid = {};

		this.dragHandlesNeedsUpdate = true;

		window.ContextMenuService.init( "dragHandleMeter", "templates/context-modals/dragHandleMeter.html", {
			constructor: function( x, y, extend ){
				this.obj = this.extend.obj;
			},
			dragHandleService: this
		});


		$rootScope.$on( "onControlModeVisibilityChanged", function ( event, visible) {

			var cs = self.handles.children;

			for (var i in cs) {
				if (cs[i].userData.dragHandleProto && !cs[i].userData.dragHandleComment) {
					cs[ i ].mesh.visible = visible;
				}
			}
		});

		$rootScope.$on( "editorEnabled", function() {
			for (var uuid in self.handles_by_uuid) {
				var obj = self.handles_by_uuid[ uuid ];
				if (obj instanceof DragHandle.Meter) {
					obj.mesh.visible = true;
				} else if (obj instanceof DragHandle.Comment) {
				}
			}
		});

		$rootScope.$on( "editorDisabled", function() {
			for (var uuid in self.handles_by_uuid) {
				var obj = self.handles_by_uuid[ uuid ];
				if (obj instanceof DragHandle.Meter) {
					obj.mesh.visible = false;
				} else if (obj instanceof DragHandle.Comment) {
				}
			}
		});



		this.addHandle = function( handle ){
			if(!( handle instanceof DragHandle )) return console.error( "DragHandlesService.addHandle :: Invalid argument! handle must be instanceof DragHandle" );

			this.handles.add( handle );
			this.handles_by_uuid[ handle.uuid ] = handle;
			if (handle.mesh) this.handles_by_uuid[ handle.mesh.uuid ] = handle;

			if (handle instanceof DragHandle.Polygon) {
				for( var i in handle.handles ) this.addHandle( handle.handles[ i ]);
				this.handles.add( handle.faces );
				this.handles.add( handle.ctrHandle );

				window.ContextMenuService.init( "dragHandle-polygon-"+handle.uuid, "templates/context-modals/dragHandlePolygon.html", {
					obj: handle
				});
			} else if (handle instanceof DragHandle.Meter) {
				this.addHandle( handle.handleA );
				this.addHandle( handle.handleB );
				this.handles.add( handle.line );
			}

			this.dragHandlesNeedsUpdate = true;

			// console.debug( "DragHandlesService.addHandle", handle, this.handles );
		};

		this.removeHandle = function( handle ){
			handle = this.solveHandle( handle );

			this.handles.remove( handle );

			delete this.handles_by_uuid[ handle.uuid ];
			if( handle.mesh ) delete this.handles_by_uuid[ handle.mesh.uuid ];

			if (handle instanceof DragHandle.Polygon) {
				window.ContextMenuService.destroy( "dragHandle-polygon-"+handle.uuid );

				delete handle.ctrHandle.$parent;
				this.removeHandle( handle.ctrHandle );

				this.handles.remove( handle.faces );

				for( var i in handle.handles ){
					delete handle.handles[ i ].$parent;
					this.removeHandle( handle.handles[ i ]);
					delete handle.handles[ i ];
				}
			} else if (handle instanceof DragHandle.Meter) {
				this.removeHandle( handle.handleA );
				this.removeHandle( handle.handleB );
				this.handles.remove( handle.line );
			}

			window.ContextMenuService.destroy( "dragHandle-"+handle.uuid );

			return handle;
		};
		this.selectHandle = function( handle ){
			if( handle ){
				handle = this.handles_by_uuid[ handle.uuid || handle ];
				console.debug( "DragHandlesService.selectHandle :: prev:",this.selected_handle, "new:",handle );
			}

			debugger;
			return window.entitySelectionService.selected_entity = handle || null;
		};

		/** @TODO: Tee kokonaan uusiksi */
		this.solveByUuid = this.solveHandle = function( handle ){
			handle = this.handles_by_uuid[ handle.uuid || handle ] || handle;
			if (!(handle instanceof DragHandle) && handle.$parent) {
				return this.solveHandle( handle.$parent );
			} else if (handle instanceof DragHandle) {
				return handle.$parent || handle;
			} else {
				if (handle.userData.type == "dragHandle" && handle.userData.dragHandle) {
					if (handle.userData.dragHandle.userData.polygonHandle) return handle.userData.dragHandle;

					return handle.userData.dragHandle.$parent || handle.userData.dragHandle;
				}
			}
			return null;
		};

		userActionHistoryService.addActs({
			"dragHandles.genProto": {
				"do": function( pos, size ){
					if( pos.z == null ) pos = parseFirstIntersect.wall( screenIntersects( pos.x, pos.y ).filter(function(v){ return !!v.face; })).point;
					if(!( pos instanceof Vector3 )) pos = new Vector3( pos.x, pos.y, pos.z );
					self.addHandle( new DragHandle.Proto( pos, size ));
				}
			},
			"dragHandles.genMeter": {
				"do": function( posA, posB ){
					var from2D;
					if (posA.z == null) {
						// Oletetaan haluttavan luoda 2D-koordinaatteihin
						from2D = posA;

						let intersect = parseFirstIntersect.wall( screenIntersects( posA.x, posA.y ).filter(function(v){ return !!v.face; }));
						posA = intersect.point;
					}

					if (!( posA instanceof Vector3 )) posA = new Vector3( posA.x, posA.y, posA.z );

					if (!posB) {
						if (from2D) try {
							let intersect = parseFirstIntersect.wall( screenIntersects( from2D.x, from2D.y + 64 ).filter(function(v){ return !!v.face; }));
							if (intersect.point) posB = intersect.point;
						} catch(e) {}
					} else if (!( posB instanceof Vector3 )) posB = new Vector3( posB.x, posB.y, posB.z );

					var handle = new DragHandle.Meter( posA, posB || posA );
					self.addHandle( handle );

					window.entitySelectionService.selected_entity = handle;
				}
			},
			"dragHandles.genComment": {
				"do": function( pos, text ){
					var intersect;
					if( pos.z == null ) pos = (intersect = parseFirstIntersect.wall( screenIntersects( pos.x, pos.y ).filter(function(v){ return !!v.face; }))).point;
					if(!( pos instanceof Vector3 )) pos = new Vector3( pos.x, pos.y, pos.z );
					var handle = new DragHandle.Comment( pos, text );
					self.addHandle( handle );
					window.entitySelectionService.selected_entity = handle;
					if (intersect) handle.setPlaceByIntersect( intersect );
				}
			},
			"dragHandles.genPolygon": {
				"do": function( pos, normal, n, r ){

					// Oletetaan astettavan pisteen olevan 2D-sijainti ruudulla
					if (pos.z == null) {
						var intersect = parseFirstIntersect.wall( screenIntersects( pos.x, pos.y ).filter(function(v){ return !!v.face; }));
						pos	= intersect.point;
						normal = intersect.face.normal;
						pos.addScaledVector( normal, DragHandle.Polygon.defaults.z_offset );
					}

					if(!( pos instanceof Vector3 )) pos = new Vector3( pos.x, pos.y, pos.z );

					r = r || 1; // "Koko" (säde)
					n = n || 4; // Kulmien lukumäärä

					var matrix = new Matrix4().lookAt( normal, new Vector3( 0, 0, 0 ), new Vector3( 0, 1, 0 ));
					var points = [];
					for( var i = 0; i < n; i++ ){
						points.push( new Vector3( r*Math.sin(( 1+i*2 )*Math.PI/n ), r*Math.cos(( 1+i*2 )*Math.PI/n )).applyMatrix4( matrix ).add( pos ));
					}
					self.addHandle( new DragHandle.Polygon( points, {}, normal ));
				}
			},
			"dragHandles.removeMeter": {
				"do": function( handle ){
					handle = self.handles_by_uuid[ handle.uuid || handle ];

					if (!handle) return;
					var json = handle.toJSON();
					json.uuid = handle.uuid;
					self.removeHandle( handle );

					userActionHistoryService.addUndo( "dragHandles.removeMeter", json );
				},
				"undo": function( act ) {
					self.addHandle( DragHandle.Meter.fromJSON( act ));
				},
				"redo": function( act, handle ) {
					handle = self.handles_by_uuid[ act.uuid ];
					self.removeHandle( handle );
				}
			},
			"dragHandles.removePolygon": {
				"do": function( handle ){
					handle = self.removeHandle( handle );
				}
			},
			"dragHandles.polygon.setColor": {
				"do": function( handle, color ){
					if( handle = self.solveHandle( handle ))
						userActionHistoryService.addUndo( "dragHandles.polygon.setColor", { uuid: handle.uuid, o: handle.opts.color, n: handle.setColor( color ) });
				},
				"undo": function( act, handle ){ if( handle = self.solveHandle( act.uuid )) handle.setColor( act.o ); },
				"redo": function( act, handle ){ if( handle = self.solveHandle( act.uuid )) handle.setColor( act.n ); }
			},
			"dragHandles.polygon.lockPlane": {
				"do": function( handle, lockPlane ){
					if( handle = self.solveHandle( handle ))
						userActionHistoryService.addUndo( "dragHandles.polygon.lockPlane", {
							uuid: handle.uuid,
							o:  !!handle.opts.lockPlane,
							n:    handle.opts.lockPlane = lockPlane == null ? !handle.opts.lockPlane : !!lockPlane
						});
				},
				"undo": function( act, handle ){ if( handle = self.solveHandle( act.uuid )) handle.opts.lockPlane = act.o; },
				"redo": function( act, handle ){ if( handle = self.solveHandle( act.uuid )) handle.opts.lockPlane = act.n; }
			},
	/*		"dragHandles.polygon.lockPlane": {
				"do": function( handle, lockPlane ){
					handle = self.solveHandle( handle );
					handle.opts.lockPlane = lockPlane == null ? !handle.opts.lockPlane : lockPlane;
				}
			}*/


			"dragHandle.move": {
				"do"   : function( obj, val ) {
					userActionHistoryService.addUndo( "dragHandle.move", {
						uuid: obj.uuid,
						old_position: obj.mesh.position.clone(),
						new_position: obj.mesh.position.copy( val )
					});
				},
				"undo": act => {
					let handle = self.solveHandle( act.uuid );
					if (!handle) return;
					if (handle.uuid != act.uuid) {
						handle = handle.handles.find( h => h.uuid == act.uuid );
					}
					if (handle) handle.setPosition( act.old_position );
				},
				"redo": act => {
					let handle = self.solveHandle( act.uuid );
					if (!handle) return;
					if (handle.uuid != act.uuid) {
						handle = handle.handles.find( h => h.uuid == act.uuid );
					}
					if (handle) handle.setPosition( act.new_position );
				},
			},
		});

		DragHandle.Polygon.loadSave = function( save ){
			self.addHandle( DragHandle.Polygon.fromJSON( save ));
	/*		self.addHandle( new DragHandle.Polygon(
				save.handles.map(function(v){ return new THREE.Vector3().fromArray(v); }),
				save.opts,
				save.normal && new THREE.Vector3().fromArray( save.normal )
			));*/
		};

		DragHandle.Comment.loadSave = function( save ){
			self.addHandle( DragHandle.Comment.fromJSON( save.json ));
		};

		DragHandle.Meter.loadSave = function( save ){
			self.addHandle( DragHandle.Meter.fromJSON( save.json ));
		};
	}
}

export function DragHandle( mesh, pos ){
	Object3D.call( this );
	this.$parent = null;
	this.mesh	= mesh;
	this.uuid	= this.mesh.uuid;
	this.add( this.mesh );
	this.mesh.userData.type = this.userData.type = "dragHandle";
	this.mesh.userData.dragHandle = this.userData.dragHandle = this;

	this.z_offset = 0;

	new ObjectClickHandler().attachTo( this );

	pos instanceof Vector3 && this.position.copy( pos );
}
DragHandle.prototype = Object.create( Object3D.prototype );
DragHandle.prototype.onChange = function() {
	// Koska oletettavasti sijainti muuttuu, halutaan päivittää varjot (ja piirtää scene muutenkin)
	gameService.shadowsNeedsUpdate = true;
};
DragHandle.prototype.onPositionChange = function() {
	this.onChange();
};
DragHandle.prototype.setPosition = function( position, vec, scale ){
	var oldPosition = this.position.clone();
	this.position.copy( position );

	if (vec instanceof Vector3 ) {
		if( !isNaN( scale = parseFloat( scale )))
		     this.position.addScaledVector( vec, scale );
		else this.position.add( vec );
	}

	if (this.onPositionChange( oldPosition, this.position ) === true ) this.position.copy( oldPosition );
};

DragHandle.prototype.setPlaceByIntersect = function( intersect ) {
	this.$lastIntersect = intersect = intersect || this.$lastIntersect;

	if (!intersect) return console.warn( "DragHandle.setPosition :: Invalid argument", arguments );

	return this.setPosition( intersect.point, intersect.face && intersect.face.normal, this.z_offset );
}

/********************************/

DragHandle.Proto = function( pos, size, material, segs ) {

	size = size || 1;

	material = material || DragHandle.Proto.defaults.glowMaterial;

	segs = segs || 8;


	this.geometry = new SphereGeometry( size, segs, segs );

	this.material = new MeshBasicMaterial({ transparent: true, colorWrite: false });

	this.size = size;


	DragHandle.call( this, new Mesh( this.geometry, this.material ), pos );


	this.userData.dragHandleProto = true;


	this.mesh.$glowMesh = new Mesh( this.geometry.clone(), material.clone() );
	this.mesh.$glowMesh.position.copy( this.mesh.position );
	this.mesh.$glowMesh.scale.multiplyScalar(1.2);
	this.mesh.$glowMesh.userData.type = "dragHandle";
	this.mesh.$glowMesh.userData.dragHandle = this;
	this.mesh.add( this.mesh.$glowMesh );


	if (!window.DEBUG) this.mesh.visible = false;
};

DragHandle.Proto.prototype = Object.create( DragHandle.prototype );
/*DragHandle.Proto.prototype.genSave = function() {
	return { type: "proto", uuid: this.uuid, json: this.toJSON() };
};
DragHandle.Proto.prototype.toJSON = function() {
	return {
		position: this.position.toArray(),
		z_offset: this.z_offset 
	};
};*/

DragHandle.Proto.defaults = {
	glowMaterial: new ShaderMaterial({
		uniforms: {
			c:          { type: "f",  value: 1.0  },
			p:          { type: "f",  value: 1.0  },
			size:       { type: "f",  value: 0.12 },
			glowColor:  { type: "c",  value: new Color( 0xff0000 ) },
			viewVector: { type: "v3", value: new Vector3() },
			pos:        { type: "v3", value: new Vector3() }
		},
		vertexShader:
		"uniform vec3 viewVector;"+
		"varying vec3 pos;"+
		"uniform float c;"+
		"uniform float p;"+
		"uniform float size;"+
		"varying float intensity;"+
		"float rand(vec2 co){ return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);}"+
		"void main() {"+
		"    vec3 vNormal = normalize( normalMatrix * normal );"+
		"    vec3 vNormel = normalize( normalMatrix * viewVector );"+
		"    pos = position;"+
		"    intensity = pow( c - dot(vNormal, vNormel), p );"+
		"    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );"+
		"}",
		fragmentShader:
		"uniform vec3  glowColor;"+
		"uniform float size;"+
		"varying vec3  pos;"+
		"varying float intensity;"+
		"void main() {"+
		"    gl_FragColor = vec4( pos / size, intensity );"+
		"}",
		side:     FrontSide,
		// blending: THREE.AdditiveBlending,
		transparent: true
	}),
/*	amigaMaterial: new THREE.ShaderMaterial({
	//uniforms: { tMatCap: { type: 't', value: new THREE.TextureLoader().load( 'media/amiga.png' ), wrapS: THREE.ClampToEdgeWrapping, wrapT: THREE.ClampToEdgeWrapping }},
	vertexShader:
		"varying vec2 vN;"+
		"void main() {"+
			"vec4 p = vec4( position, 1. );"+
			"vec3 e = normalize( vec3( modelViewMatrix * p ));"+
			"vec3 n = normalize( normalMatrix * normal );"+
			"vec3 r = reflect( e, n );"+
			"float m = 2. * sqrt( pow( r.x, 2. ) + pow( r.y, 2. ) + pow( r.z + 1., 2. ));"+
			"vN = r.xy / m + .5;"+
			"gl_Position = projectionMatrix * modelViewMatrix * p;"+
		"}",
	fragmentShader:
		"uniform sampler2D tMatCap;"+
		"varying vec2 vN;"+
		"void main(){ gl_FragColor = vec4( texture2D( tMatCap, vN ).rgb, 1.0 ); }",
	flatShading: false
	})*/
}

/********************************/

DragHandle.Comment = function( pos, comments ) {

	DragHandle.Proto.call( this, pos, 0.1 );

	this.z_offset = DragHandle.Comment.defaults.z_offset || this.z_offset;

	this.comments = new CommentsHandler( this, comments );

	this.isStatic = false;

	this.mesh.$glowMesh.material.copy( DragHandle.Comment.defaults.glowMaterial.clone() ); 
	this.mesh.visible = true;

	this.userData.dragHandleComment = true;
};
DragHandle.Comment.prototype = Object.create( DragHandle.Proto.prototype );
DragHandle.Comment.prototype.genSave = function() {
	return { type: "comment", json: this.toJSON() };
};
DragHandle.Comment.prototype.toJSON = function() {
	return {
		position  : this.position.toArray(),
		z_offset  : this.z_offset,
		comments  : this.comments.toJSON(),
		clickActs : this.$clickHandler && this.$clickHandler.acts || null
	};
};
DragHandle.Comment.fromJSON = function( json ) {
	var handle = new DragHandle.Comment(
		new Vector3().fromArray( json.position ),
		json.comments
	);
	if (!isNaN( json.z_offset )) handle.z_offset = json.z_offset;
	if (json.clickActs) new ObjectClickHandler( json.clickActs, handle );
	return handle;
};
DragHandle.Comment.defaults = {
	glowMaterial: new ShaderMaterial({
		uniforms: {
			c:          { type: "f",  value: 1.0  },
			glowColor:  { type: "c",  value: new Color( 0x03a9f4 ) },
			viewVector: { type: "v3", value: new Vector3() },
			pos:        { type: "v3", value: new Vector3() }
		},
		vertexShader:
		"uniform vec3 viewVector;"+
		"varying vec3 pos;"+
		"uniform float c;"+
		"varying float intensity;"+
		"float rand(vec2 co){ return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);}"+
		"void main() {"+
		"    vec3 vNormal = normalize( normalMatrix * normal );"+
		"    vec3 vNormel = normalize( normalMatrix * viewVector );"+
		"    intensity = pow( 1.1 - dot(vNormal, vNormel), 1. );"+
		"    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );"+
		"}",
		fragmentShader:
		"uniform vec3  glowColor;"+
		"varying float intensity;"+
		"void main() {"+
		"    gl_FragColor = vec4( glowColor, intensity );"+
		"}",
		side:     FrontSide,
		// blending: THREE.AdditiveBlending,
		transparent: true
	})
};

/********************************/

DragHandle.Polygon = function( handles, opts, normal ){
	var self = this;

	if( !Array.isArray( handles ) || handles.length < 3 ) throw new Error( "DragHandle.Polygon :: Invalid argument!" );
	this.handles = handles;

	opts = opts || {};
	this.opts = {};
	this.opts.lockPlane = opts.lockPlane == null ? DragHandle.Polygon.defaults.lockPlane : !!opts.lockPlane;
	this.opts.color     =     opts.color == null ? DragHandle.Polygon.defaults.color     :   opts.color;

	// @TODO: Laita sopivaan paikkaan
	let isMoveable = opts.isMoveable == null ? true : !!opts.isMoveable;

	this.plane  = new Plane( this.normal = normal );
	var mx  = new Matrix4().lookAt( this.normal, new Vector3( 0, 0, 0 ), new Vector3( 0, 1, 0 ));
	var pos = new Vector3();
	for (let i in this.handles) pos.add( this.handles[ i ]);
	pos.multiplyScalar( 1 / this.handles.length );

	this.ctrHandle = new DragHandle.Proto( pos, 0.1 );
	this.ctrHandle.mesh.userData.type = "dragHandle";
	this.ctrHandle.$parent = this;
	DragHandle.call( this, this.ctrHandle.mesh, this.ctrHandle.position );

	// @TODO: Laita sopivaan paikkaan
	this.userData.moveable = isMoveable;

	this.z_offset = DragHandle.Polygon.defaults.z_offset || 0;

	this.comments = new CommentsHandler( this );

	this.handles.forEach(( handle, i ) => {
		this.handles[i] = new DragHandle.Proto( handle, 0.1 );

		this.handles[i].onPositionChange = () => {
			this.refresh();
			this.onChange();
		};

		this.handles[i].userData.polygonHandle = true;
		this.handles[i].$parent = this;
	});

	this.material = new MeshPhongMaterial({ side: DoubleSide });
	this.faces	  = new Group();
	this.faces.receiveShadow = true;

	for (var mesh, i = 0; i < this.handles.length; i++) {
		mesh = new Mesh( new Geometry(), this.material );
		mesh.receiveShadow = true;
		mesh.geometry.vertices.push( this.position, this.handles[ i ].position, this.handles[ (i+1)%this.handles.length ].position );
		mesh.geometry.faces.push( new Face3( 0, 1, 2 ));
		mesh.userData.type              = "dragHandle";
		mesh.userData.dragHandlePolygon = true;
		mesh.userData.wall              = true;
		mesh.$parent = this;
		this.faces.add( mesh );
	}

	this.setColor( this.opts.color );
	this.refresh();
};
DragHandle.Polygon.prototype = Object.create( DragHandle.Proto.prototype );

DragHandle.Polygon.prototype.refresh = function(){
	this.position.set( 0, 0, 0 );

	for( var i in this.handles ){
		this.position.x += this.handles[i].position.x;
		this.position.y += this.handles[i].position.y;
		this.position.z += this.handles[i].position.z;
	}
	this.position.x /= this.handles.length;
	this.position.y /= this.handles.length;
	this.position.z /= this.handles.length;

	this.refreshFaces();
};
DragHandle.Polygon.prototype.setColor = function( color ){
	this.opts.color = "#"+this.material.color.set( color ).getHexString();
};
DragHandle.Polygon.prototype.refreshFaces = function(){
	for( var i in this.faces.children ){
		this.faces.children[ i ].geometry.computeFaceNormals();
		this.faces.children[ i ].geometry.computeBoundingSphere();
		this.faces.children[ i ].geometry.verticesNeedUpdate = true;
	}
};
DragHandle.Polygon.prototype.onPositionChange = function( oldPosition ){
	var delta = this.position.clone().sub( oldPosition );
	for( var i in this.handles ) this.handles[i].position.add( delta );
	this.refreshFaces();
	this.onChange();
};
DragHandle.Polygon.prototype.genSave = function(){
	let isMoveable = isObjectMoveable( this, true );
	return { type: "polygon",
		opts: {
			...this.opts,
			isMoveable
		},
		handles   : this.handles.map(function(v){ return v.position.toArray(); }),
		normal    : this.normal.toArray(),
		comments  : this.comments && this.comments.toJSON() || null,
		clickActs : this.$clickHandler && this.$clickHandler.acts || null
	};
};
DragHandle.Polygon.fromJSON = function( save ){
	var handle = new DragHandle.Polygon(
		save.handles.map(function(v){ return new Vector3().fromArray(v); }),
		save.opts,
		save.normal && new Vector3().fromArray( save.normal )
	);
	if (save.comments && handle.comments) handle.comments.init( save.comments );
	if (save.clickActs) new ObjectClickHandler( save.clickActs, handle );

	return handle;
};

DragHandle.Polygon.defaults = {
	z_offset  : 0.01,
	lockPlane : true,
	color     : 0xaaaaaa
};

/***************************************************/

DragHandle.Meter = function( handleA, handleB, opts ){
	var self = this;

	opts = opts || {};
	this.opts = {};
	this.opts.lockPlane = opts.lockPlane == null ? false    : !!opts.lockPlane;
	this.opts.color     =     opts.color == null ? 0xaaaaaa :   opts.color;

	this.line = new Helpers.Line();

	this.handleA = new DragHandle.Proto( handleA.clone(), 0.05, DragHandle.Meter.defaults.endMaterial, 16 );
	this.handleB = new DragHandle.Proto( handleB.clone(), 0.05, DragHandle.Meter.defaults.endMaterial, 16 );

	angular.extend( this.handleA.userData = this.handleB.userData, {
		type        : "dragHandle",
		meterHandle : true,
		meter       : this
	});
	this.handleA.onPositionChange = this.handleB.onPositionChange = function() {
		self.refresh.apply( self, arguments );
		self.onPositionChange();
	};

	DragHandle.call( this, this.line, this.handleA.position.clone() );

	this.z_offset = DragHandle.Meter.defaults.z_offset || 0.001;

	this.comments = new CommentsHandler( this );

	this.length = null;

	this.refresh();
};

DragHandle.Meter.prototype = Object.create( DragHandle.prototype );

DragHandle.Meter.prototype.refresh = function(){

	this.line.setEnds( this.handleA.position, this.handleB.position );

	this.length = this.line.length;
};

DragHandle.Meter.prototype.genSave = function() {
	return { type: "meter", json: this.toJSON() };
};

DragHandle.Meter.prototype.toJSON = function(){
	return {
		opts      : this.opts,
		handleA   : this.handleA.position.toArray(),
		handleB   : this.handleB.position.toArray(),
		normal    : this.normal        && this.normal.toArray() || null,
		comments  : this.comments      && this.comments.toJSON() || null,
		clickActs : this.$clickHandler && this.$clickHandler.acts || null
	};
};
DragHandle.Meter.fromJSON = function( json ){
	var handle = new DragHandle.Meter(
		new Vector3().fromArray( json.handleA ),
		new Vector3().fromArray( json.handleB ),
		json.opts || {}
	);
	if (json.comments && handle.comments) handle.comments.init( json.comments );
	if (json.clickActs) new ObjectClickHandler( json.clickActs, handle );
	return handle;
};

DragHandle.Meter.defaults = {
	z_offset: 0.02,
	endMaterial: new ShaderMaterial({
		uniforms: {
			c:          { type: "f",  value: 1.0  },
			glowColor:  { type: "c",  value: new Color( 0x00ff00 ) },
			viewVector: { type: "v3", value: new Vector3() },
			pos:        { type: "v3", value: new Vector3() }
		},
		vertexShader:
		"uniform vec3 viewVector;"+
		"varying vec3 pos;"+
		"uniform float c;"+
		"varying float intensity;"+
		"float rand(vec2 co){ return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);}"+
		"void main() {"+
		"    vec3 vNormal = normalize( normalMatrix * normal );"+
		"    vec3 vNormel = normalize( normalMatrix * viewVector );"+
		"    intensity = pow( 1. - dot(vNormal, vNormel), 3. );"+
		"    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );"+
		"}",
		fragmentShader:
		"uniform vec3  glowColor;"+
		"varying float intensity;"+
		"void main() {"+
		"    gl_FragColor = vec4( glowColor, intensity );"+
		"}",
		side:     FrontSide,
		// blending: THREE.AdditiveBlending,
		transparent: true
	})
};
